import { useQuery } from "@tanstack/react-query";
import { getProductsDatasource } from "../services/products";
import { HookOptions, useStatsQuery } from "../extensions/sw/modules/stats/hooks";
import { StatsQuery } from "../extensions/sw/modules/stats/types";
import { MatchFilter } from "../libs/statsFilters";
import { GlobalStatsSelection } from "../types/stats";
import { WorkerQueryOptions } from "../libs/workers/types";

export function useProductsDatasource(tag: string = "Prodotto") {
  return useQuery({
    queryKey: ["products-datasource", tag],
    queryFn: () => getProductsDatasource(tag),
    gcTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}


export const useProductSummaries = (
  data: {
    selection?: GlobalStatsSelection;
    filters?: MatchFilter;
    opts?: WorkerQueryOptions;
  },
  opts: HookOptions<typeof StatsQuery.PRODUCT_SUMMARIES>
) => {
  return useStatsQuery(
    {
      type: StatsQuery.PRODUCT_SUMMARIES,
      data: {  cityEscapeIds: data.selection?.cityEscapeIds, productIds: data.selection?.productIds, filters: data.filters },
      opts: {
        ...data.opts,
        traceKey: data.opts?.traceKey ?? "useProductSummaries",
      },
    },
    opts
    );
};
